import Icon from "@mui/icons-material/LocalShipping";
import FmbThaliDeliveryList from "./FmbThaliDeliveryList";

export default {
  list: FmbThaliDeliveryList,
  icon: Icon,
  label: "Daily thalis",
  options: { label: "Daily thalis" },
  name: "fmbThaliDelivery",
};
